import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';
import { debounce } from '@beef/utils';

/**
 * @desc: Хук для получения и установки в виде переменной CSS (--storyMobileHeight)
 * реальной доступной высоты мобильного устройства.
 */
export var useMobileWindowHeight = function useMobileWindowHeight(variableCSS) {
  var _window;
  var isMobile = useIsMobileDimension();
  var ref = useRef(null);
  var _useState = useState((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  useEffect(function () {
    var handleResize = debounce(200, function () {
      setHeight(window.innerHeight);
    });
    window.addEventListener('resize', handleResize);
    handleResize();

    // eslint-disable-next-line consistent-return
    return function () {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel();
    };
  }, []);
  useEffect(function () {
    if (ref.current && isMobile && variableCSS) {
      ref.current.style.setProperty(variableCSS, "".concat(height, "px"));
    }
  }, [isMobile, height, variableCSS]);
  return ref;
};